import React, {Component} from 'react';
import {View, Text} from 'react-native';
import {noticeStyles, noticeTones} from './boxChampNoticeStyles';

const POLL_MS = 2500;
const MAX_POLLS = 12;

export function shouldShowRecalculatingNotice(order, isBoxChamp, scanningStarted) {
  const dirty = order?.basicinfo?.box_champ_dirty ?? order?.box_champ_dirty;
  return !!(isBoxChamp && dirty && !scanningStarted);
}

export default class BoxChampRecalculatingNotice extends Component {
  state = {gaveUp: false};

  componentDidMount() {
    this._timer = null;
    this._polls = 0;
    this.sync();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this._polls = 0;
      if (this.state.gaveUp) this.setState({gaveUp: false}, () => this.sync());
    }
    this.sync();
  }

  componentWillUnmount() {
    this.stop();
  }

  sync() {
    const active =
      this.props.visible && !this.state.gaveUp && typeof this.props.onRefetch === 'function';
    if (active && !this._timer) {
      this._timer = setInterval(() => {
        this._polls += 1;
        if (this._polls >= MAX_POLLS) {
          this.stop();
          this.setState({gaveUp: true});
          return;
        }
        this.props.onRefetch();
      }, POLL_MS);
    } else if (!active) {
      this.stop();
    }
  }

  stop() {
    if (this._timer) {
      clearInterval(this._timer);
      this._timer = null;
    }
  }

  render() {
    if (!this.props.visible) return null;
    if (this.state.gaveUp) {
      // Do not reuse the "boxchamp-recalculating-notice" testID here: that id means
      // "still trying" for the rest of the app (including the existing regression
      // spec), and it must never render again once we've stopped. Distinguishing
      // "we gave up" from "it worked" is the whole point of this fix — vanishing
      // silently is the bug.
      return (
        <View
          testID="boxchamp-recalculating-gave-up"
          style={[noticeStyles.banner, {backgroundColor: noticeTones.danger.background}]}>
          <Text style={[noticeStyles.text, {color: noticeTones.danger.text}]}>
            Still recalculating boxes — this is taking longer than expected. Reload the order to
            check the latest plan.
          </Text>
        </View>
      );
    }
    return (
      <View
        testID="boxchamp-recalculating-notice"
        style={[noticeStyles.banner, {backgroundColor: noticeTones.warning.background}]}>
        <Text style={[noticeStyles.text, {color: noticeTones.warning.text}]}>
          Order changed — recalculating boxes…
        </Text>
      </View>
    );
  }
}
